import { v4 as uuidv4 } from 'uuid';

export function FormInputUpload(props = {}, childrenComponents = []) {
	return {
		componentName: 'FormInputUpload',
		componentId: uuidv4(),
		props: Object.assign(
			{
				pointer: '',
				accept: '',
			},
			props,
		),
		childrenComponents,
	};
}
